export default __webpack_public_path__ + "static/media/NWC_Main.42bb80ea.png";